"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var CmsBannersRouteImagesListCtl = /** @class */ (function (_super) {
    __extends(CmsBannersRouteImagesListCtl, _super);
    function CmsBannersRouteImagesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_banner_route_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.banner_route_id; });
        _this.dk_banner_route_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.banner_route_title; });
        _this.dk_app_language_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_language_id; });
        _this.dk_app_language_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_language_title; });
        _this.dk_image_url = UIUtils_1.UIUtils.IProp2Str(function (o) { o.image_url; });
        _this.dk_priority = UIUtils_1.UIUtils.IProp2Str(function (o) { o.priority; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_is_navigate_banner = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_navigate_banner; });
        _this.dk_banner_navigate_url = UIUtils_1.UIUtils.IProp2Str(function (o) { o.banner_navigate_url; });
        //public readonly dk_is_show_button = UIUtils.IProp2Str((o: ICmsBannersRouteImagesListItem) => { o.is_show_button });
        //public readonly dk_is_navigate_button = UIUtils.IProp2Str((o: ICmsBannersRouteImagesListItem) => { o.is_navigate_button });
        //public readonly dk_button_navigate_url = UIUtils.IProp2Str((o: ICmsBannersRouteImagesListItem) => { o.button_navigate_url });
        //public readonly dk_button_text = UIUtils.IProp2Str((o: ICmsBannersRouteImagesListItem) => { o.button_text });
        //public readonly dk_button_css_class = UIUtils.IProp2Str((o: ICmsBannersRouteImagesListItem) => { o.button_css_class });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_banner_auth_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.banner_auth_type_code; });
        _this.dk_banner_auth_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.banner_auth_type_title; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        return _this;
    }
    CmsBannersRouteImagesListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0,
            cdn_baseurl: ""
        };
    };
    CmsBannersRouteImagesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "object with id [" + id + "] not found !";
    };
    CmsBannersRouteImagesListCtl.prototype.LoadData = function (bannerUrlId, onDone) {
        var _this = this;
        webAApi_1.ListBannerRouteImagesByBannerRouteIdGet.exec({ banner_route_id: bannerUrlId }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            _this.DATA.cdn_baseurl = resp.cdn_baseurl;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    banner_route_id: resp.list[i].banner_route_id,
                    banner_route_title: resp.list[i].banner_route_title,
                    app_language_id: resp.list[i].app_language_id,
                    app_language_title: resp.list[i].app_language_title,
                    image_url: resp.list[i].image_url,
                    priority: resp.list[i].priority,
                    is_locked: resp.list[i].is_locked,
                    is_navigate_banner: resp.list[i].is_navigate_banner,
                    banner_navigate_url: resp.list[i].banner_navigate_url,
                    //is_show_button: resp.list[i].is_show_button,
                    //is_navigate_button: resp.list[i].is_navigate_button,
                    //button_navigate_url: resp.list[i].button_navigate_url,
                    //button_text: resp.list[i].button_text,
                    //button_css_class: resp.list[i].button_css_class,
                    title: resp.list[i].title,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    banner_auth_type_code: resp.list[i].banner_auth_type_code,
                    banner_auth_type_title: resp.list[i].banner_auth_type_title
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    CmsBannersRouteImagesListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBannerRouteImage.exec({
            data: {
                banner_route_id: data.banner_route_id,
                app_language_id: data.app_language_id,
                image_url: data.image_url,
                priority: data.priority,
                is_locked: data.is_locked,
                is_navigate_banner: data.is_navigate_banner,
                banner_navigate_url: data.banner_navigate_url,
                //is_show_button: data.is_show_button,
                //is_navigate_button: data.is_navigate_button,
                //button_navigate_url: data.button_navigate_url,
                //button_text: data.button_text,
                //button_css_class: data.button_css_class,
                title: data.title,
                banner_auth_type_code: data.banner_auth_type_code
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                banner_route_id: data.banner_route_id,
                banner_route_title: resp.banner_route_title,
                app_language_id: data.app_language_id,
                app_language_title: resp.app_language_title,
                image_url: data.image_url,
                priority: data.priority,
                is_locked: data.is_locked,
                is_navigate_banner: data.is_navigate_banner,
                banner_navigate_url: data.banner_navigate_url,
                //is_show_button: data.is_show_button,
                //is_navigate_button: data.is_navigate_button,
                //button_navigate_url: data.button_navigate_url,
                //button_text: data.button_text,
                //button_css_class: data.button_css_class,
                title: data.title,
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                date_changed2: moment(resp.date_added_uts_ms).utc(false),
                banner_auth_type_code: data.banner_auth_type_code,
                banner_auth_type_title: resp.banner_auth_type_title
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    CmsBannersRouteImagesListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditBannerRouteImage.exec({
                data: {
                    banner_route_image_id: data.key,
                    app_language_id: data.app_language_id,
                    image_url: data.image_url,
                    priority: data.priority,
                    is_locked: data.is_locked,
                    is_navigate_banner: data.is_navigate_banner,
                    banner_navigate_url: data.banner_navigate_url,
                    //is_show_button: data.is_show_button,
                    //is_navigate_button: data.is_navigate_button,
                    //button_navigate_url: data.button_navigate_url,
                    //button_text: data.button_text,
                    //button_css_class: data.button_css_class,
                    title: data.title,
                    banner_auth_type_code: data.banner_auth_type_code
                }
            }, function (resp) {
                _tmp.app_language_id = data.app_language_id;
                _tmp.image_url = data.image_url;
                _tmp.priority = data.priority;
                _tmp.is_locked = data.is_locked;
                _tmp.is_navigate_banner = data.is_navigate_banner;
                _tmp.banner_navigate_url = data.banner_navigate_url;
                //_tmp.is_show_button = data.is_show_button;
                //_tmp.is_navigate_button = data.is_navigate_button;
                //_tmp.button_navigate_url = data.button_navigate_url;
                //_tmp.button_text = data.button_text;
                //_tmp.button_css_class = data.button_css_class;
                _tmp.title = data.title;
                _tmp.banner_auth_type_code = data.banner_auth_type_code;
                _tmp.banner_auth_type_title = resp.banner_auth_type_title;
                _tmp.app_language_title = resp.app_language_title;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    CmsBannersRouteImagesListCtl.prototype.SetPriority = function (bannerRputeImageId, Priority, onDone) {
        var _this = this;
        var _tmp = this.getById(bannerRputeImageId);
        if (_tmp) {
            webAApi_1.DoSetBannerRouteImagePriority.exec({
                data: {
                    banner_route_image_id: bannerRputeImageId,
                    priority: Priority
                }
            }, function (resp) {
                _tmp.priority = Priority;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    CmsBannersRouteImagesListCtl.prototype.SetIsLocked = function (bannerRouteImageId, IsLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(bannerRouteImageId);
        if (_tmp) {
            webAApi_1.DoSetBannerRouteImageIsLocked.exec({
                data: {
                    banner_route_image_id: bannerRouteImageId,
                    is_locked: IsLocked
                }
            }, function (resp) {
                _tmp.is_locked = IsLocked;
                _tmp.date_changed2 = moment(resp.date_changed_ots_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    CmsBannersRouteImagesListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    CmsBannersRouteImagesListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBannerRouteImage.exec({ data: { banner_route_image_id: key } }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return CmsBannersRouteImagesListCtl;
}(BaseController_1.BaseController));
exports.CmsBannersRouteImagesListCtl = CmsBannersRouteImagesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_banners/ctl/CmsBannersRouteImagesListCtl.ts
// module id = 946
// module chunks = 0